export default function PlayNoitification() {
    let x = document.getElementById("audio");
    console.log("try to play=> ",x )
    //x.play();
}